<div class="entity-management-container">
  <div *ngIf="loading" class="loading-overlay">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <div class="entity-table-wrapper">
    <!-- Header Bar -->
    <div class="entity-header-bar" *ngIf="data?.header">
      <div class="header-left">
        <!-- Dropdowns -->
        <ng-container *ngFor="let dropdown of data.header.dropdowns">
          <div class="header-dropdown">
            <label>{{ dropdown.label }}</label>
            <mat-form-field appearance="outline" class="material-dropdown">
              <mat-select [value]="dropdown.defaultValue" (selectionChange)="onDropdownSelectionChange(dropdown.key, $event.value)">
                <mat-option *ngFor="let option of dropdown.options" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
      </div>

      <div class="header-center">
        <span class="header-title">{{ headerTitle }}</span>
      </div>

      <div class="header-right">
        <!-- Action Icons -->
        <ng-container *ngFor="let action of data.header.actions">
          <button class="header-icon" mat-icon-button (click)="handleHeaderAction(action.actionId)" [matTooltip]="action.tooltip">
            <mat-icon>{{ action.icon }}</mat-icon>
          </button>
        </ng-container>
      </div>
    </div>

    <!-- Table Container -->
    <div class="table-container">
      <div class="table-body">
          <table>
            <thead>
              <tr>
                <th class="checkbox-col" [style.width.px]="columnWidths[0]">
                  <mat-checkbox [checked]="allSelected" (change)="toggleAllSelection()"></mat-checkbox>
                </th>
                <th 
                  *ngFor="let col of data.columns; let i = index" 
                  [style.width.px]="columnWidths[i + 1]" 
                  (click)="col.sortable && sortBy(col.key)" 
                  [class.sortable]="col.sortable">
                  <div class="header-content">
                    <span>{{ col.label }}</span>
                    <mat-icon *ngIf="col.sortable">{{ getSortIcon(col.key) }}</mat-icon>
                  </div>
                  <div class="resizer" (mousedown)="onResizeStart($event, i + 1)"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="!loading">
                <tr 
                  *ngFor="let record of records" 
                  (click)="selectRecord(record)"
                  [class.selected]="record === selectedRecord">
                  <td class="checkbox-col" [style.width.px]="columnWidths[0]">
                    <mat-checkbox [checked]="selection.has(record)" (change)="toggleSelection(record)"></mat-checkbox>
                  </td>
                  <td *ngFor="let col of data.columns; let i = index" [style.width.px]="columnWidths[i + 1]">{{ record[col.key] }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <div *ngIf="!loading && records.length === 0" class="no-records">
              No records found.
          </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="entity-footer-bar" *ngIf="data?.pagination?.enabled">
      <span>Rows: {{ records.length }}</span> |
      <span>Page Size: {{ data.pagination.pageSize }}</span> |
      <span>Current Page: 1</span>
    </div>
  </div>
</div>